<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type}`"
    :data-type="context.type"
	v-click-outside="close"
  >

	<div class="input-search" >
		<i v-if="context.slotProps.component.iconInput && opened" :class="context.slotProps.component.iconInput" ></i>
		<input
			ref="inputSearchInput"
			type="text"
			v-model="searchInput"
			autocomplete="no"
			@keydown.enter.prevent="select"
			@keydown.down.prevent="increment"
			@keydown.up.prevent="decrement"
			@keyup="search"
			@focus="open"
		>
	</div>
	
	<ul v-if="opened" class="formulate-input-dropdown">
		<li
			v-for="(option, index) in filteredOptions"
			:key="index"
			:data-is-selected="selectedIndex === index"
			@mouseenter="selectedIndex = index"
			@click="select"
		>
			<i v-if="context.slotProps.component.iconList && opened" :class="context.slotProps.component.iconList" ></i>
			{{option[keyLabel]}}
		</li>
	</ul>
</div>
</template>

<script>
export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},
	data () {
		return {
			filteredOptions: [],
			selectedIndex: 0,
			opened:false,
			searchInput: '',
		}
	},
	computed: {
		model: {
			get: function() {
				return this.context.model || null
			},
			set: function(newValue) {
				this.context.model = newValue;
			}
		},
		selected (){
			if(this.context.options && this.model){
				console.log(this.model)
				return this.context.options.find(option => option[this.keyValue] == this.model[this.keyValue])
			}
			return null
		},
		keyValue(){
			return this.context.slotProps.component.keyValue || 'value'
		},
		keyLabel(){
			return this.context.slotProps.component.keyLabel || 'label'
		},
	},
	watch: {
		selected: function(newValue, oldValue) {
			this.searchInput = newValue ? newValue[this.keyLabel] :''
		}
	},

	methods: {
		open () {
			this.filteredOptions = this.context.options
			this.opened = true
			this.$nextTick(() => {
				this.$refs.inputSearchInput.focus()
			})
		},
		close(){
			this.opened = false
		},
		
		search(){
			if (Array.isArray(this.context.options) && this.searchInput) {
				this.filteredOptions = this.context.options.filter(option => option[this.keyLabel].toLowerCase().includes(this.searchInput.toLowerCase()))
			}else{
				this.filteredOptions = this.context.options
			}
		},

		select(){
			this.opened = false
			const selected = this.filteredOptions[this.selectedIndex]
			this.context.model = selected
			this.$emit('selected', this.context.model)
		},
		increment () {
			const length = this.filteredOptions.length
			if (this.selectedIndex + 1 < length) {
				this.selectedIndex++
			} else {
				this.selectedIndex = 0
			}
		},
		decrement () {
			const length = this.filteredOptions.length
			if (this.selectedIndex - 1 >= 0) {
				this.selectedIndex--
			} else {
				this.selectedIndex = length - 1
			}
		}
	}
}
</script>

<style scoped lang="scss">
.formulate-element-input{
	position: relative;
}

.input-search{
	height: 32px;
	width: 100%;
    display: flex;
	align-items: center;

	.icon{
		margin-left: 6px;
	}
}
.selected{
	width: 100%;
	height: 32px;
	font-size: .9em;
    padding: 0.75em;
    display: block;
}

.formulate-input-dropdown{
  position: absolute;
    z-index: 10;
  width: 100%;
  max-height: 240px;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
  color: inherit;
  outline: none;
  overflow: auto;

  li{
    list-style: none;
    padding: 14px 10px;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;
	display: flex;
	align-items: center;

    &:hover{
      background-color: #eee;
    }
	.icon{
		font-size: 20px;
		color: #999;
		margin-right: 10px;
		margin-left: 5px;
	}
  }
  li[data-is-selected="true"]{
    background-color: #eee;
  }
}
</style>